// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/default/fonts/bta-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("resources/default/fonts/bta-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("resources/default/fonts/bta-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("resources/default/fonts/bta-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-500.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-700.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("resources/eften/fonts/roboto-v27-latin_cyrillic-700.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#bta-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'bta icons';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
    font-weight: normal;
    font-style: normal;
}

/* roboto-regular - latin_cyrillic */
@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); /* IE9 Compat Modes */
    src: local(''),
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype'); /* Safari, Android, iOS */
}

/* roboto-500 - latin_cyrillic */
@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); /* IE9 Compat Modes */
    src: local(''),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype'); /* Safari, Android, iOS */
}

/* roboto-700 - latin_cyrillic */
@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); /* IE9 Compat Modes */
    src: local(''),
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('truetype'); /* Safari, Android, iOS */
}

* {
    scrollbar-width: thin;
    scrollbar-color: #d3d5e6;
}

html,
body {
    height: 100%;
}

body {
    margin: 0;
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
        'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fff !important;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 0.01071em;
}
p {
    line-height: 1.75rem;
}
a {
    background-color: transparent !important;
    text-decoration-color: transparent !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}
code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

[class*='bta-icon-']:before {
    display: inline-block;
    font-family: 'bta icons';
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.bta-icon-exclamation:before {
    content: '\\0041';
}
.bta-icon-attachment:before {
    content: '\\0042';
}
.bta-icon-send-email:before {
    content: '\\0043';
}
.bta-icon-bell:before {
    content: '\\0044';
}
.bta-icon-file:before {
    content: '\\0045';
}
.bta-icon-chevron-left:before {
    content: '\\0046';
}
.bta-icon-chevron-right:before {
    content: '\\0047';
}
.bta-icon-times:before {
    content: '\\0048';
} /* close */
.bta-icon-check:before {
    content: '\\0049';
}
.bta-icon-filter:before {
    content: '\\004a';
}
.bta-icon-analytics-graph-bar:before {
    content: '\\004b';
}
.bta-icon-door-code:before {
    content: '\\004c';
}
.bta-icon-home-with-remote:before {
    content: '\\004d';
}
.bta-icon-log-out:before {
    content: '\\004e';
}
.bta-icon-settings-gear:before {
    content: '\\004f';
}
.bta-icon-shield:before {
    content: '\\0050';
}
.bta-icon-wrench:before {
    content: '\\0051';
}
.bta-icon-files:before {
    content: '\\0052';
}
.bta-icon-home:before {
    content: '\\0053';
}
.bta-icon-menu:before {
    content: '\\0054';
}
.bta-icon-message:before {
    content: '\\0055';
}
.bta-icon-wallet:before {
    content: '\\0056';
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
input:autofill {
    box-shadow: 0 0 0 1000px white inset !important;
}

h2 {
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/resources/eften/styles.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,4CAAiD;IACjD;;;6DAGwE;IACxE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,4CAAuE,EAAE,qBAAqB;IAC9F;;;;kEAIyF,EAAE,yBAAyB;AACxH;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,6CAAmE,EAAE,qBAAqB;IAC1F;;;;mEAIqF,EAAE,yBAAyB;AACpH;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,6CAAmE,EAAE,qBAAqB;IAC1F;;;;mEAIqF,EAAE,yBAAyB;AACpH;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT;oCACgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,wCAAwC;IACxC,6CAA6C;IAC7C,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,wCAAwC;AAC5C;AACA;IACI,+EAA+E;AACnF;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB,EAAE,UAAU;AACZ;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,uDAAuD;AAC3D;AACA;IACI,+CAA+C;AACnD;;AAEA;IACI,SAAS;AACb","sourcesContent":["@font-face {\n    font-family: 'bta icons';\n    src: url('resources/default/fonts/bta-icons.eot');\n    src: url('resources/default/fonts/bta-icons.woff') format('woff'),\n        url('resources/default/fonts/bta-icons.eot?#iefix') format('embedded-opentype'),\n        url('resources/default/fonts/bta-icons.ttf') format('truetype'),\n        url('resources/default/fonts/bta-icons.svg#bta-icons') format('svg');\n    font-weight: normal;\n    font-style: normal;\n}\n\n/* roboto-regular - latin_cyrillic */\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    src: url('resources/eften/fonts/roboto-v27-latin_cyrillic-regular.eot'); /* IE9 Compat Modes */\n    src: local(''),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-regular.woff') format('woff'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-regular.woff2') format('woff2'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-regular.eot?#iefix') format('embedded-opentype'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-regular.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n/* roboto-500 - latin_cyrillic */\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 600;\n    src: url('resources/eften/fonts/roboto-v27-latin_cyrillic-500.eot'); /* IE9 Compat Modes */\n    src: local(''),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-500.woff') format('woff'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-500.woff2') format('woff2'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-500.eot?#iefix') format('embedded-opentype'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-500.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n/* roboto-700 - latin_cyrillic */\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 700;\n    src: url('resources/eften/fonts/roboto-v27-latin_cyrillic-700.eot'); /* IE9 Compat Modes */\n    src: local(''),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-700.woff') format('woff'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-700.woff2') format('woff2'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-700.eot?#iefix') format('embedded-opentype'),\n        url('resources/eften/fonts/roboto-v27-latin_cyrillic-700.ttf') format('truetype'); /* Safari, Android, iOS */\n}\n\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #d3d5e6;\n}\n\nhtml,\nbody {\n    height: 100%;\n}\n\nbody {\n    margin: 0;\n    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n        'Helvetica Neue', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: #fff !important;\n    font-size: 0.875rem;\n    line-height: 1.43;\n    letter-spacing: 0.01071em;\n}\np {\n    line-height: 1.75rem;\n}\na {\n    background-color: transparent !important;\n    text-decoration-color: transparent !important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n[class*='bta-icon-']:before {\n    display: inline-block;\n    font-family: 'bta icons';\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.bta-icon-exclamation:before {\n    content: '\\0041';\n}\n.bta-icon-attachment:before {\n    content: '\\0042';\n}\n.bta-icon-send-email:before {\n    content: '\\0043';\n}\n.bta-icon-bell:before {\n    content: '\\0044';\n}\n.bta-icon-file:before {\n    content: '\\0045';\n}\n.bta-icon-chevron-left:before {\n    content: '\\0046';\n}\n.bta-icon-chevron-right:before {\n    content: '\\0047';\n}\n.bta-icon-times:before {\n    content: '\\0048';\n} /* close */\n.bta-icon-check:before {\n    content: '\\0049';\n}\n.bta-icon-filter:before {\n    content: '\\004a';\n}\n.bta-icon-analytics-graph-bar:before {\n    content: '\\004b';\n}\n.bta-icon-door-code:before {\n    content: '\\004c';\n}\n.bta-icon-home-with-remote:before {\n    content: '\\004d';\n}\n.bta-icon-log-out:before {\n    content: '\\004e';\n}\n.bta-icon-settings-gear:before {\n    content: '\\004f';\n}\n.bta-icon-shield:before {\n    content: '\\0050';\n}\n.bta-icon-wrench:before {\n    content: '\\0051';\n}\n.bta-icon-files:before {\n    content: '\\0052';\n}\n.bta-icon-home:before {\n    content: '\\0053';\n}\n.bta-icon-menu:before {\n    content: '\\0054';\n}\n.bta-icon-message:before {\n    content: '\\0055';\n}\n.bta-icon-wallet:before {\n    content: '\\0056';\n}\n\ninput:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0 1000px white inset !important;\n}\ninput:autofill {\n    box-shadow: 0 0 0 1000px white inset !important;\n}\n\nh2 {\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
